import {COMMENT_TIME_UPDATE_ENDS, INCORRECT_COMMENT_USER} from "Core/error-codes";

const COMMENT_EDITING_IS_OUT_OF_TIME_LIMIT = 'Вы можете редактировать сообщение в течение первых 5 минут. К сожалению, <span>время вышло.</span>';
const INCORRECT_USER = '<span>Редактирование невозможно.</span> Вы не можете редактировать комментарии других пользователей';

export const getMessageByErrorCode = (errorCode) => {
    switch (errorCode) {
        case COMMENT_TIME_UPDATE_ENDS:
            return COMMENT_EDITING_IS_OUT_OF_TIME_LIMIT;
        case INCORRECT_COMMENT_USER:
            return INCORRECT_USER;
    }

    return 'Непредвиденная ошибка. Сообщите, пожалуйста, нам';
};
